import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import * as i0 from "@angular/core";
import * as i1 from "./shared/services/authentication.service";
import * as i2 from "@angular/router";
var AuthenticationGuard = /** @class */ (function () {
    function AuthenticationGuard(authenticator, router) {
        this.authenticator = authenticator;
        this.router = router;
    }
    AuthenticationGuard.prototype.canActivate = function (next, state) {
        var authorities = next.data['authorities'];
        var authorized = false;
        if (authorities) {
            var user = this.authenticator.getCurrentUser();
            if (user) {
                authorized = user.hasAnyOfAuthorities(authorities);
            }
        }
        else {
            authorized = this.authenticator.isLoggedIn();
        }
        if (!authorized) {
            var route = next.data['redirectTo'];
            this.router.navigate(route ? route : ['/login'], { queryParams: { returnUrl: state.url } });
        }
        return authorized;
    };
    AuthenticationGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthenticationGuard_Factory() { return new AuthenticationGuard(i0.inject(i1.AuthenticationService), i0.inject(i2.Router)); }, token: AuthenticationGuard, providedIn: "root" });
    return AuthenticationGuard;
}());
export { AuthenticationGuard };
